import React, { Dispatch, useContext } from 'react';
import { MediaLibraryTypeFilterGroup } from '../../../../components/filters/MediaLibraryTypeFilterGroup';
import { MediaLibraryOriginFilterGroup } from '../../../../components/filters/MediaLibraryOriginFilterGroup';
import { MediaLibraryProportionFilterGroup } from '../../../../components/filters/MediaLibraryProportionFilterGroup';
import { MediaLibraryFilterAction, MediaLibraryFilterType } from '../../../../models/media';
import { ButtonMenuContext } from '../../../../components/actions/ButtonMenu/ButtonMenu.view';
import { FilterGroupsContainer } from '../../../../components/containers/FilterGroupsContainer';
import { useBreakpoints } from '../../../../hooks/useBreakpoints';
import { BreakpointsEnum } from '../../../../constants/breakpoints';

export enum FilterMenuContextType {
  'DROPDOWN' = 1,
  'MODAL'
}

export type MediaLibraryFilterMenuViewProps = {
  filters: MediaLibraryFilterType;
  dispatchFilters: Dispatch<MediaLibraryFilterAction>;
  context: FilterMenuContextType;
};

export const MediaLibraryFilterMenuView = (props: MediaLibraryFilterMenuViewProps): JSX.Element => {
  const { filters, dispatchFilters, context } = props;
  const isFilterActive = Object.values(filters).some(f => !!f);
  const { openHandler } = useContext(ButtonMenuContext);
  const breakpoint = useBreakpoints();
  const shouldShowClearButton = isFilterActive && breakpoint === 'small';

  const isDropdown =
    context === FilterMenuContextType.DROPDOWN
      ? breakpoint !== BreakpointsEnum.small && breakpoint !== BreakpointsEnum.xxlarge
      : false;

  return (
    <FilterGroupsContainer
      isDropdown={isDropdown}
      showClearButton={shouldShowClearButton}
      reset={() => dispatchFilters({ type: 'resetAll' })}
      close={() => {
        openHandler(false);
      }}>
      <MediaLibraryTypeFilterGroup
        loading={false}
        dispatchFilters={dispatchFilters}
        activeFilterId={filters.type || undefined}
      />
      <MediaLibraryOriginFilterGroup
        loading={false}
        dispatchFilters={dispatchFilters}
        activeFilterId={filters.origin || undefined}
      />
      <MediaLibraryProportionFilterGroup
        loading={false}
        dispatchFilters={dispatchFilters}
        activeFilterId={filters.proportion || undefined}
      />
    </FilterGroupsContainer>
  );
};
